module.exports = __webpack_public_path__ + "img/banner04_03.d5d04a42.png";